module.exports = __webpack_public_path__ + "img/p22.5056d68e.png";